import React, { Component } from "react";
import { withRouter } from "react-router";
import ComponentContainer from "../../Components/ComponentContainer/ComponentContainer";
import { Spinner } from "../../Components/Spinner/Spinner";

import { marketPlaceParam } from "../../assets/Js/paramName";
import projectSettings from "../../assets/Js/projectSettings";
import { callAPI } from "../../assets/Js/backendCommunication";
import { trackTypes } from "../../assets/Js/trackTypeEnum";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import { getUserData } from "../../assets/Js/tokenHandler";
import { Link } from "react-router-dom";
import { getPlainToken } from "../../assets/Js/tokenHandler";

export default withRouter(
  class TrackJoiningPage extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isScreenLoading: false,
        search: "",
        trackId: "",
        trackName: "",
        trackType: "",
        gymName: "",
        gymImage: "",
        showPasswordField: false,
        trackPassword: "",
        showErrorMessage: false,
        errorMessage: "",
        userId: "",
        userImage: "",
      };
    }

    extractTrackDetails = async () => {
      const paramName = marketPlaceParam;
      const search = this.props.location.search;
      const trackId = new URLSearchParams(search).get(paramName);
      let url = `${projectSettings.baseUrl}/tracks/${trackId}`;
      let header = false;
      let data = null;
      let type = "GET";
      let token = getPlainToken();

      let response = "";

      this.setState({ isScreenLoading: true });

      response = await callAPI(url, header, type, data, token);

      if (response) {
        this.setState({ isScreenLoading: false });

        if (response?.status === 200) {
          const userData = getUserData();
          await this.setState({
            trackId: response?.data?.Id,
            trackName: response?.data?.Name,
            trackType: response?.data?.Type,
            userId: userData.Id,
            userImage: userData.Image,
          });
        } else {
          this.setState({
            showErrorMessage: true,
            errorMessage: "No such track found!",
          });
        }
      }
    };
    componentDidMount() {
      this.extractTrackDetails().then(() => {
        this.subsribeThisUserToATrack();
      });
    }

    subsribeThisUserToATrack = async () => {
      if (this.state.trackId) {
        if (this.state.trackType?.toLowerCase() === trackTypes.private) {
          this.setState({
            showPasswordField: true,
          });
        } else {
          this.joinTheTrack();
        }
      }
    };

    joinTheTrack = async () => {
      let url = `${projectSettings.baseUrl}/gyms/joingym`;
      let type = "POST";
      let header = true;
      let data = null;
      let token = null;
      let userId = this.state.userId;

      data = {
        UserId: userId,
        TrackId: this.state.trackId,
        TrackPassword: this.state.trackPassword,
      };
      let response = "";

      if (response === "") {
        this.setState({ isScreenLoading: true, showErrorMessage: false });
      }
      response = await callAPI(url, header, type, JSON.stringify(data), token);
      if (response) {
        this.setState({ isScreenLoading: false });
        apiResponseToast(response.status, "joinTrack", response.data?.message);

        if (response.type === "error") {
          this.setState({
            showErrorMessage: true,
            errorMessage: response.data?.message,
          });
        } else if (response.type === "success") {
          if (this.state.trackType?.toLowerCase() === trackTypes.paid) {
            window.location.replace(response.data?.SessionUrl);
          } else {
            this.props.history.push(`/successpage${this.state.search}`);
          }
        }
      }
    };

    passwordHandler = (e) => {
      this.setState({
        trackPassword: e.target.value,
      });
    };

    hanldeSubmit = (e) => {
      e.preventDefault();
      this.joinTheTrack();
    };

    render() {
      return (
        <ComponentContainer
          showBackBtn={true}
          backActionHandler={() => this.props.history.goBack()}
          image={this.state.gymImage}
          title={this.state.gymName}
        >
          {this.state.isScreenLoading && !this.state.showPasswordField ? (
            <Spinner />
          ) : (
            <>
              {this.state.showErrorMessage && (
                <p className="my-3 text-center text-danger">
                  {this.state.errorMessage}
                </p>
              )}
              {this.state.showPasswordField && (
                <form onSubmit={this.hanldeSubmit}>
                  <div class="form-group">
                    <label for="exampleInputPassword1">
                      Enter Track Password
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={this.passwordHandler}
                    />
                  </div>
                  <div className="w-25 mx-auto">
                    <button
                      type="submit"
                      class="basicBtnStyle primaryBtn mx-auto"
                    >
                      {this.state.isScreenLoading ? (
                        <Spinner />
                      ) : (
                        <span>Join</span>
                      )}
                    </button>
                  </div>
                </form>
              )}
              <div className="cornerBtnStyle">
                <Link to="/" className="text-white">
                  <button className="basicBtnStyle secondaryBtn ml-5 mt-3">
                    Home
                  </button>
                </Link>
              </div>
            </>
          )}
        </ComponentContainer>
      );
    }
  }
);
